<script lang="ts">
	import { cn } from '$utils/cn';

	interface Props {
		variant?: 'solid' | 'outline' | 'ghost';
		href?: string;
		target?: '_blank' | '_self' | '_parent' | '_top';
		rel?: string;
		children?: () => any;
		class?: string;
		'aria-label'?: string;
		onclick?: () => void;
		onmouseover?: () => void;
		onmouseout?: () => void;
		onfocus?: () => void;
		onblur?: () => void;
	}

	const {
		href,
		target,
		rel,
		children,
		variant = 'solid',
		class: className = '',
		onclick,
		onmouseover,
		onmouseout,
		onfocus,
		onblur,
		'aria-label': ariaLabel = ''
	}: Props = $props();
</script>

<svelte:element
	this={href ? 'a' : 'button'}
	role={href ? 'link' : 'button'}
	{href}
	{target}
	{rel}
	{onclick}
	{onmouseover}
	{onmouseout}
	{onfocus}
	{onblur}
	aria-label={ariaLabel}
	class={cn(
		'text-soft hover:text-primary cursor-pointer rounded-xl p-2.5 font-semibold transition-all duration-300',
		variant === 'solid' && 'bg-primary text-background hover:text-background/80',
		variant === 'outline' && 'border border-white bg-none text-white dark:border-gray-400',
		className
	)}
>
	{@render children?.()}
</svelte:element>
